import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const GoldLink = ({ to, children, testId, className = "" }) => (
  <Link
    data-testid={testId}
    to={to}
    className={`group inline-flex items-center gap-2.5 bg-gold px-7 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-ink hover:text-sand sm:text-sm ${className}`}
  >
    {children}
    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
  </Link>
);

export const GhostLink = ({ to, children, testId, dark = false, className = "" }) => (
  <Link
    data-testid={testId}
    to={to}
    className={`group inline-flex items-center gap-2.5 border px-7 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] transition-colors duration-300 sm:text-sm ${
      dark
        ? "border-sand/25 text-sand hover:border-gold hover:text-gold"
        : "border-ink/20 text-ink hover:border-gold hover:text-gold-dark"
    } ${className}`}
  >
    {children}
    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
  </Link>
);
